import styled from 'styled-components';
import { StyledButton } from '../index.styles';

export const StyledPrimaryButton = styled(StyledButton)`
    margin-top: ${({ theme }) => theme.global.spaces.xRay};
    opacity: 0.8;
`;
